import React, { useState } from "react";
import { MdorViewer } from "./styles";
import { Document, Page, pdfjs } from "react-pdf";
import { message } from "antd";

// Set up the PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const Dashboard: React.FC = () => {
    const viewDocument: string = JSON.parse(localStorage.getItem("MDOR_FILE") || '');
    const mdorToken: string = JSON.parse(localStorage.getItem("MDOR_FILE_TOKEN") || '');
    const [numPages, setNumPages] = useState(0);
    const [zoom, setZoom] = useState<number>(1);
    const [loadError, setLoadError] = useState<string | null>(null);
    
    // Configure the PDF file with proper authorization headers
    const mdorFile = {
        url: viewDocument,
        httpHeaders: { Authorization: `Bearer ${mdorToken}` }
    };

    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setLoadError(null);
        setNumPages(numPages);
    };
    
    const onDocumentLoadError = (error: Error) => {
        console.error("Error loading PDF document:", error);
        setLoadError("Failed to load the document. Authentication may have expired.");
        message.error("Failed to load the document. Please try logging in again.");
    };
    
    return (
        <MdorViewer>
            <div className="pdf-container">
                {loadError ? (
                    <div className="error-message">
                        <p>{loadError}</p>
                        <button 
                            onClick={() => window.location.href = "/login"}
                            className="login-button"
                        >
                            Go to Login
                        </button>
                    </div>
                ) : (
                    <>
                        <Document
                            file={mdorFile}
                            onLoadSuccess={onDocumentLoadSuccess}
                            onLoadError={onDocumentLoadError}
                            className="pdf-document"
                            loading={<div className="loading">Loading document...</div>}
                        >
                            {Array.from(new Array(numPages), (el, index) => (
                                <Page
                                    key={`page_${index + 1}`}
                                    pageNumber={index + 1}
                                    scale={zoom}
                                    renderTextLayer={false}
                                    loading={<div className="loading">Loading page...</div>}
                                    error={<div className="page-error">Error loading this page</div>}
                                />
                            ))}
                        </Document>
                        
                        {numPages > 0 && (
                            <div className="controls">
                                <button
                                    type="button"
                                    className="zoom-btn zoom-btn--in"
                                    onClick={() => setZoom(zoom + 0.25)}
                                >
                                    &#x2b;
                                </button>
                                <button
                                    type="button"
                                    className="zoom-btn zoom-btn--out"
                                    onClick={() => setZoom(zoom > 1 ? zoom - 0.25 : 1)}
                                    disabled={zoom <= 1}
                                >
                                    &#x2013;
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </MdorViewer>
    );
};

export default Dashboard;
